const Beavis = {
  level1: '#E3ECFF',
  B50: '#E3ECFF',
  level2: '#BED0E5',
  B100: '#BED0E5',
  level3: '#9DB0C9',
  B200: '#9DB0C9',
  level4: '#7B91AE',
  B300: '#7B91AE',
  level5: '#627A99',
  B400: '#627A99',
  level6: '#486586',
  B500: '#486586',
  level7: '#3B5775',
  B600: '#3B5775',
  level8: '#2C4560',
  B700: '#2C4560',
  level9: '#1E334A',
  B800: '#1E334A',
  level10: '#0B2033',
  B900: '#0B2033',
};

export { Beavis };
